import { FormTemplateNormalizationField } from '../models/form-template.model';

export class StoreObject {

	public constructor() {
		this.CurrentStoreObj = new StoreObjectKey();
		this.PreviewStoreObj = new StoreObjectKey();
		this.TargetIsRoot = false;
		this.FormDataHasErrors = false;
		this.FormTemplateNormalizationFields = [];
	}

	public Schema: { [key: string]: any };
	public UiSchema: { [key: string]: any };
	public FormData: { [key: string]: any };
	public FormTemplateNormalizationFields?: FormTemplateNormalizationField[];
	public FormDataHasErrors: boolean;
	public CurrentStoreObj: StoreObjectKey;
	public PreviewStoreObj: StoreObjectKey;
	public TargetIsRoot: boolean;
	public Type: StoreObjectType;
}

export class NormalizationField {
	public fieldId: string = null;
	public normalizationFieldId?: number = null;
	public formTemplateNormalizationFieldStatusId?: number = null;
	public normalizationFieldExceptionCriteriaId?: number = null;
	public normalizationFieldExceptionCriteriaValue: string = null;
	public exceptionAlias: string = null;
	public exceptionTypeId?: number = null;
}

export class StoreObjectKey {
	public SectionName: string;
	public FieldName: string;
	public AnyOfOptionName: string;
}

export enum StoreObjectType {
	Field,
	Section,
	AnyOf,
	AnyOfField
}
